import GET_EMAIL_BY_TOKEN from './getEmailByToken.gql';
import REMOVE_SESSION from './removeSession.gql';
import LOG_OUT from './logOut.gql';

export {
  GET_EMAIL_BY_TOKEN,
  REMOVE_SESSION,
  LOG_OUT,
};
